import React from "react";
import DefaultLayout from "../../Layouts/DefaultLayout";
import { useStoreContext } from "../../Contexts/StoreContext";
import DefaultLayoutProfile from "../../Layouts/DefaultLayoutProfile";
import CardProfileCards from "../../Components/Layout/Profile/CardProfileCards";
import CardProfileAddresses from "../../Components/Layout/Profile/CardProfileAddresses";
import CardProfileOrders from "../../Components/Layout/Profile/CardProfileOrders";
import CardProfileBasicInfo from "../../Components/Layout/Profile/CardProfileBasicInfo";
import CardBoxDefault from "../../Components/Layout/CardBoxDefault";

const ProfileHome = () => {
    const { currentStore } = useStoreContext();
    document.title = 'Perfil';

    return (
        <DefaultLayout showHeader={currentStore}>
            <DefaultLayoutProfile>

                <section className="grid h-full gap-4 md:grid-cols-2 text-sm">
                    <CardBoxDefault>
                        <CardProfileBasicInfo />
                    </CardBoxDefault>

                    <CardBoxDefault className="row-span-3">
                        <CardProfileOrders />
                    </CardBoxDefault>

                    <CardBoxDefault>
                        <CardProfileAddresses />
                    </CardBoxDefault>

                    <CardBoxDefault>
                        <CardProfileCards />
                    </CardBoxDefault>
                </section>

            </DefaultLayoutProfile>
        </DefaultLayout>
    );
};

export default ProfileHome;